import { createAsyncThunk } from "@reduxjs/toolkit";
import { ProjectManagerAxios } from "api/ProjectManagerAxios";



export const fetchProjectManagerResourceRequestRequestLog = createAsyncThunk(
  "projectManager/fetchProjectManagerResourceRequestRequestLog",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }
    const response: any = await ProjectManagerAxios.get(
      `/project-manager/resource-request/logs/?${params.toString()}`
    );
   
    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const exportProjectManagerManpowerCSV = async () => {
  const response = await ProjectManagerAxios.get(
    "/project-manager/manpower/export-to-excel/",
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "purchaseRequest.csv",
  };
};



